<script setup lang="ts">
import BaseSection from '@/application/shared/infrastructure/components/BaseSection.vue';

defineExpose({
  sectionSubmit: () => true
});
</script>
<template>
  <BaseSection class="flex-1 items-center text-center">
    SectionThanks
  </BaseSection>
</template>
